import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';

@Component({
  selector: 'app-kb-data-extraction-request',
  templateUrl: './kb-data-extraction-request.component.html',
  styleUrl: './kb-data-extraction-request.component.scss',
  standalone: false
})
export class KbDataExtractionRequestComponent implements OnInit {

  currentComponent: string;


  private dataExtractionService = inject(KbDataExtractionRequestService);
  private cdr = inject(ChangeDetectorRef);
  private subscription = new Subscription();
  constructor() {

  }
  ngOnInit(): void {
    this.subscription.add(this.dataExtractionService.currentComponent$.subscribe((x) => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'dataExtractionOverview';
      }
      this.cdr.detectChanges();
    }));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
